var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon__list"},[(_vm.list.length)?_c('SlideWrap',{style:(_vm.style)},_vm._l((_vm.list),function(coupon){return _c('CouponItem',{key:coupon.couponId,attrs:{"coupon":coupon},on:{"click":function($event){return _vm.getDiscount(coupon.couponId)}}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }